// extracted by mini-css-extract-plugin
export default {"loader":"FaceListItem__loader--3B7rI"};